/**
 * App analytics: Google Analytics 4 events through the gtag.js tag that
 * public/index.html already loads (G-FQQNG1D6J7). GA4 naming: snake_case event
 * and parameter names, no personal data (no user ids, phone or email).
 * Never throws; a missing / blocked tag is a no-op.
 */
export type AnalyticsParams = Record<string, string | number | boolean | null | undefined>;

type Gtag = (command: 'event', name: string, params?: Record<string, unknown>) => void;

export function trackEvent(name: string, params: AnalyticsParams = {}): void {
  try {
    const g = (typeof window !== 'undefined' ? (window as unknown as { gtag?: Gtag }).gtag : undefined);
    if (typeof g !== 'function') return;
    const clean = Object.fromEntries(
      Object.entries(params)
        .filter(([, v]) => v !== undefined && v !== null)
        .map(([k, v]) => [k, typeof v === 'string' ? v.slice(0, 100) : v])
    );
    g('event', name, clean);
  } catch {
    /* analytics must never break the app */
  }
}
